export const MOBILE_FOOTER_HEIGHT = 80;

export const HEADER_BUTTON_WIDTH = 40;

export const SKELETON_CARDS_HEIGHT = [280, 430, 340, 360, 460, 280, 430, 280];
